<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado borderTop v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" />
  <MensagemIpi v-else-if="regra == 0" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">ICMS</h2>
    <QuadroAlerta
      v-if="!!imposto.dados.length"
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :borderTop="!imposto.dados.length || !exibeAlerta"
      :titulo="imposto.nome"
      :classe="imposto.classe"
    >
      <RegistrosIcmsInterno
        :id="id"
        :bssnSelecionado="bssnSelecionado"
        :imposto="imposto"
        :seleciona="seleciona"
        :selecionado="registroSelecionado"
        :selecionouIcmsInterno="selecionouIcmsInterno"
        :edita="edita"
        :reduzAliquota="reduzAliquota"
        :classe="nomeImposto"
        :loading="loading"
      />
    </QuadroPrincipal>
    <FundoIcms
      v-if="regraFundo"
      :id="id"
      :fundo="imposto.fundo"
      :classe="imposto.classe"
      :seleciona="selecionaFundo"
      :fundoSelecionado="fundoSelecionado"
      :selecionouFundo="selecionouFundo"
      :edita="editaFundo"
      :aliquotaEfetivaSelecionada="aliquotaEfetivaSelecionada"
      :loading="loading"
    />
    <QuadroComplementoIcms
      v-if="regraComplemento"
      :classe="imposto.classe"
      :nome="imposto.nome"
      :complemento="imposto.complementoDeAliquota"
      :seleciona="selecionaComplemento"
      :complementoSelecionado="complementoSelecionado"
      :selecionouComplemento="selecionouComplemento"
      :edita="editaComplemento"
      :cargaEfetivaTributaria="cargaEfetivaTributaria"
      :loading="loading"
    />
    <BeneficiosIcms
      v-if="regraBeneficios"
      :key="forceRerenderKeyBeneficios"
      :beneficios="beneficiosIcms"
      :beneficioSelecionado="beneficioSelecionado"
      :classe="imposto.classe"
      :seleciona="selecionaBeneficio"
      :selecionouBeneficio="selecionouBeneficio"
    />
    <LoadingResultado v-if="loading" :titulo="''" :classe="nomeImposto" />
  </div>
</template>

<script>
import BeneficiosIcms from "@/components/BeneficiosIcms/BeneficiosIcms.vue";
import QuadroComplementoIcms from "@/components/QuadroComplementoIcms/QuadroComplementoIcms.vue";
import FundoIcms from "@/components/FundoIcms/FundoIcms.vue";
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import MensagemIpi from "@/components/MensagemIpi/MensagemIpi.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RegistrosIcmsInterno from "@/components/RegistrosIcmsInterno/RegistrosIcmsInterno.vue";

import stringFormatMixin from "@/mixins/stringFormatMixin";
import rotaBufferMixin from "@/mixins/rotaBufferMixin";

import { mapGetters, mapActions } from "vuex";
import QuadroAlerta from "../../../components/QuadroAlerta/QuadroAlerta.vue";
export default {
  name: "IcmsInterno",

  props: {
    id: String | Number,
    bssnSelecionado: Array,
    buscarImposto: Function,
    tributoAtivo: String,
    exibeImposto: Boolean,
    limparImpostos: Boolean
    // dadosForm: Array | Object
  },

  inject: ["alteracaoImportacao"],

  components: {
    BeneficiosIcms,
    FundoIcms,
    LoadingResultado,
    MensagemIpi,
    MensagemErro,
    MultiplosSemResultado,
    QuadroPrincipal,
    QuadroComplementoIcms,
    RegistrosIcmsInterno,
    QuadroAlerta
  },

  mixins: [rotaBufferMixin, stringFormatMixin],

  data() {
    return {
      exibeAlerta: false,
      beneficiosIcms: [],
      titulo: "ICMS",
      ativarLoading: false,
      ativarLoadingSecundario: false,
      nomeImposto: "icms_interno",
      icmsComplemento: null,
      complementoSelecionado: {},
      selecionouIcmsInterno: false,
      selecionouFundo: false,
      selecionouComplemento: false,
      requerFundo: true,
      requerComplemento: true,
      imposto: null,
      registroSelecionado: {},
      fundoSelecionado: {},
      beneficioSelecionado: {},
      beneficios: null,
      beneficioClasse: null,
      dadosForm: {},
      chamadaBuffer: [],
      selecionouBeneficio: false,
      regra: 0,
      forceRerenderKeyBeneficios: 0,
      erro: false,
      reduzAliquota: 0
    };
  },

  created() {
    this.setSelecao({ selecao: { selecionouIcms: this.selecionouIcms }, id: this.id });
  },

  updated() {
    if (this.selecionouIcms) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      this.regra = this.getDadosForm[this.id].regra;
      if (newValue == this.nomeImposto && !this.imposto && this.regra != 0 && this.exibeImposto) {
        this.dadosForm = { ...this.getDadosForm[this.id] };
        this.ativarLoading = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
        this.ativarLoading = false;
      }
    },

    limparImpostos(newValue) {
      if (newValue) {
        this.imposto = null;
        this.edita();
        this.editaFundo();
        this.editaComplemento();
        this.editaBeneficios();
      }
    },

    ativarLoading() {
      this.$emit("loading", this.ativarLoading);
    },

    loading() {
      this.$emit("loading", this.loading);
    },

    selecionouIcms() {
      this.setSelecao({ selecao: { selecionouIcms: this.selecionouIcms }, id: this.id });
    }
  },

  computed: {
    ...mapGetters("resultado", ["getPossiveisAbas"]),
    ...mapGetters("form", ["getDadosForm"]),
    ...mapGetters("reRender", ["getRenderKey"]),

    loading() {
      if (this.ativarLoading || this.ativarLoadingSecundario) {
        return true;
      }
      return false;
    },

    listaBeneficios: {
      get: function() {
        return this.beneficiosIcms;
      },

      set: function(newVal) {
        return newVal;
      }
    },

    aliquotaEfetivaSelecionada() {
      if (this.selecionouIcmsInterno && this.selecionouFundo) {
        // CÁLCULO DE ALÍQUOTA EFETIVA BASEADO NA REGRA DO FUNDO
        if (this.fundoSelecionado.regra_fundo == 2) {
          this.reduzAliquota = this.fundoSelecionado.aliquota;
          return Number(this.registroSelecionado.aliquota);
        } else {
          this.reduzAliquota = 0;
          return Number(this.registroSelecionado.aliquota) + Number(this.fundoSelecionado.aliquota);
        }
        // FIM
      }
      this.reduzAliquota = 0;
      return null;
    },

    cargaEfetivaTributaria: function() {
      return (
        parseFloat(this.registroSelecionado.aliquota) +
          parseFloat(this.complementoSelecionado.aliquota) || null
      );
    },
    regraFundo() {
      if (
        !!this.imposto.fundo.dados &&
        this.selecionouIcmsInterno &&
        this.registroSelecionado.label &&
        this.registroSelecionado.label.toLowerCase().replaceAll(" ", "") != "nãoincidência"
      ) {
        return true;
      }
      return false;
    },

    regraComplemento() {
      if (
        !!this.imposto.complementoDeAliquota.length &&
        !this.ativarLoadingSecundario &&
        this.registroSelecionado.label &&
        this.registroSelecionado.label.toLowerCase().replaceAll(" ", "") != "alíquotaregrageral" &&
        this.selecionouIcmsInterno
      ) {
        return true;
      }
      return false;
    },

    regraBeneficios() {
      if (
        (!!this.beneficiosIcms.length || this.alteracaoImportacao) &&
        !this.ativarLoadingSecundario &&
        this.selecionouIcmsInterno &&
        this.registroSelecionado.label &&
        this.registroSelecionado.label.toLowerCase().replaceAll(" ", "") != "nãoincidência"
      ) {
        return true;
      }
      return false;
    },
    selecionouIcms() {
      const selecionou = [
        this.selecionouIcmsInterno,
        !this.requerFundo || this.selecionouFundo,
        !this.requerComplemento || this.selecionouComplemento
      ];
      return !selecionou.filter(boolean => boolean == false).length;
    },

    impressaoLog() {
      let log = {
        logIcms: {
          icms: this.registroSelecionado,
          fundo: this.fundoSelecionado,
          complemento: this.complementoSelecionado,
          beneficio: this.beneficioSelecionado
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("form", ["setDadosForm"]),
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    async seleciona(imposto) {
      this.registroSelecionado = imposto;
      this.selecionouIcmsInterno = true;

      this.verificaTrocaDeAliquota(imposto.aliquota);

      //ENVIA PARA DEMAIS IMPOSTOS A ALIQUOTA DE ICMS INTERNO SELECIONADO
      // if(this.getPossiveisAbas.includes('ICMS_CARGA_LIQUIDA')) {
      let form = this.getDadosForm[this.id];
      if (imposto.aliquota) {
        form.aliquotaIcmsSelecionada = +imposto.aliquota;
      } else if (imposto.medida_aplicada) {
        form.aliquotaIcmsSelecionada = Number(
          imposto.medida_aplicada
            .toString()
            .replace(",", ".")
            .replace("%", "")
        );
      } else {
        //ajustar valor para aliquota caso não venha aliquota ou medida_aplicada
        form.aliquotaIcmsSelecionada = 0;
      }
      this.setDadosForm({ id: this.id, dadosForm: form });
      // }
      //FIM ENVIO
      let tentativas = 0;
      this.ativarLoadingSecundario = true;
      while (tentativas < 3) {
        try {
          let response = await this.chamadaRota("Cenario/obterBeneficioIcms", form);
          this.beneficiosIcms = response.beneficio;
          tentativas = 3;
        } catch (error) {
          tentativas++;
          console.error(`${tentativas}ª tentativa`);
          if (tentativas === 3) {
            console.error(error);
            this.erro = true;
            this.ativarLoadingSecundario = false;
          }
        }
      }
      this.ativarLoadingSecundario = false;

      this.requerComplemento = this.imposto ? !!this.imposto.complementoDeAliquota.length : true;
      this.requerFundo = this.imposto ? !!this.imposto.fundo.dados.length : true;
    },

    async selecionaFundo(imposto) {
      this.fundoSelecionado = imposto;
      this.selecionouFundo = true;
    },

    selecionaComplemento(imposto) {
      this.complementoSelecionado = imposto;
      this.selecionouComplemento = true;
    },

    selecionaBeneficio(id) {
      this.beneficios = this.beneficiosIcms.map(beneficio => {
        if (beneficio.id_imposto == id) {
          this.beneficioSelecionado = beneficio.selecionado ? beneficio : {};
          this.selecionouBeneficio = beneficio.selecionado;
          this.beneficioClasse = beneficio.classe;
        } else {
          beneficio.selecionado = false;
        }

        return beneficio;
      });

      this.forceRerenderKeyBeneficios += 1;
    },

    edita() {
      this.registroSelecionado = {};
      this.selecionouIcmsInterno = false;
      this.reduzAliquota = 0;
      this.editaFundo();
      this.editaComplemento();
      this.editaBeneficios();
      // REMOVE aliquotaIcmsSelecionada
      let form = this.getDadosForm[this.id];
      delete form.aliquotaIcmsSelecionada;
      this.setDadosForm({ id: this.id, dadosForm: form });
      // FIM
    },

    editaFundo() {
      this.fundoSelecionado = {};
      this.selecionouFundo = false;
    },

    editaComplemento() {
      this.complementoSelecionado = {};
      this.selecionouComplemento = false;
    },

    editaBeneficios() {
      this.beneficioSelecionado = {};
      this.selecionouBeneficio = false;
      if (this.imposto && this.beneficiosIcms) {
        this.beneficiosIcms.map(beneficio => {
          beneficio.selecionado = false;
        });
      }
    },

    verificaTrocaDeAliquota(aliquota) {
      //VERIFICA SE A ALIQUOTA SELECIONADA ANTERIORMENTE É DIFERENTE DA NOVA ALIQUOTA SELECIONADA
      if (
        !!this.getDadosForm[this.id].aliquotaIcmsSelecionada &&
        aliquota !== this.getDadosForm[this.id].aliquotaIcmsSelecionada
      ) {
        this.$bus.$emit("limparImposto", "icms_interno");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
